import { BaseEntity, JsonApiProperty, JsonApiResource } from '../jsonapi-provider';

@JsonApiResource({ type: 'supply' })
export default class Supply extends BaseEntity {
  @JsonApiProperty({ resolver: Number }) price = 0.0;
  name = '';
  description = '';

  constructor(
    id?: Supply['id'],
    name: Supply['name'] = '',
    description: Supply['description'] = '',
    price: Supply['price'] = 0.0
  ) {
    super();
    this.id = id;
    this.name = name;
    this.description = description;
    this.price = price;
  }
}
